import React, { useEffect, useRef, useState } from 'react';
// import './styles.css';
//internal and external componentscontainers
import { Typography, Paper, Box, Fade, Popper, ClickAwayListener, Button, ThemeProvider, createTheme, TextField } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar, faXmark,faFileExcel, faPlus } from '@fortawesome/free-solid-svg-icons';
import { colors } from '../../common/pallette/colors';
import ActionContents from '../ActionContents';
import EvidenceContents from '../EvidenceContents';
import CommentsContents from '../CommentsContents';
import EvaluationContents from '../EvaluationContents';
import { Accordion, AccordionSummary } from '../../common/AccordionsCustomized';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import CompanyDetails from '../CompanyDetails';
import ContactDetails from '../ContactDetails';
import { genUID } from '../../common/StaticExports';
import { useDispatch, useSelector } from 'react-redux';
import StafffDetails from '../StaffDetails';
import FacilityDetails from '../FacilityDetails';
import TeamsDetails from '../TeamsDetails';
import AccountingDetails from '../AccountingDetails';
import PlayersDetails from '../PlayersDetails';
import AdminActionContents from '../AdminActionContents';
import { getLicenceStandardsMetadata } from '../../api/licence';
import { setLicenceCriteriaEvidences, setSelectedLicenceStandard } from '../../redux/reducers/licence';
import './styles.css';
import { saveCompanyDetails, saveContactDetails, saveFacilities, savePlayers, saveProfitAndLoss, saveStaffDetails, saveSupportFund, saveTeamDetails } from '../../api/dataCapture';
import DataCaptureHeaders from '../DataCaptureHeaders';
import { setFacilitiesDetails, setIsUpdatedFacility, setIsUpdatedPlayer, setIsUpdatedProfitAndLoss, setIsUpdatedStaff, setIsUpdatedSupportFund, setIsUpdatedTeam, setPlayerDetails, setProfitAndLossDetails, setStaffDetails, setSupportFundDetails, setTeamDetails } from '../../redux/reducers/dataCaptures';
import { Navigators } from '../../components/Navigators';


const theme = createTheme({
    components: {
        MuiPaper: {
            styleOverrides: {
                root: {
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    marginTop: '7%'
                },
            }
        },
        MuiTypography: {
            styleOverrides: {
                root: {
                    fontSize: 13
                }
            }
        },
        MuiInputBase: {
            styleOverrides: {
                input: {
                    fontSize: 13
                }
            }
        },
        MuiAccordion: {
            styleOverrides: {
                root: {
                    marginTop: 0
                }
            }
        }
    }
})


const LicenceStandardsDetail = (props: {detail: any, isOpen: boolean, handleClose: any}) => {
    const { detail, isOpen, handleClose } = props;
    const selectedLicenceStandard = useSelector((state:any) =>  state.licence.selectedLicenceStandard);
    const [expanded, setExpanded] = useState(false);
    const dispatch = useDispatch();
    const currentClub = useSelector((state:any) => state.clubDetails);
    const companyDetails = useSelector((state:any) => state.dataCaptures.companyDetails);
    const contactDetails = useSelector((state:any) => state.dataCaptures.contactDetails);
    const toggleExpanded = () => setExpanded((prev) => !prev);
    const staffDetails = useSelector((state:any) => state.dataCaptures.staffDetails);
    const facilitiesDetails = useSelector((state:any) => state.dataCaptures.facilitiesDetails);
    const teamDetails = useSelector((state:any) => state.dataCaptures.teamDetails);
    const playerDetails = useSelector((state:any) => state.dataCaptures.playerDetails);
    const isUpdatedStaff = useSelector((state:any) => state.dataCaptures.isUpdatedStaff);
    const isUpdatedFacility = useSelector((state:any) => state.dataCaptures.isUpdatedFacility);
    const isUpdatedTeam = useSelector((state:any) => state.dataCaptures.isUpdatedTeam);
    const profitAndLossDetails = useSelector((state:any) => state.dataCaptures.profitAndLossDetails);
    const supportFundDetails = useSelector((state:any) => state.dataCaptures.supportFundDetails);
    const isUpdatedProfitAndLoss = useSelector((state:any) => state.dataCaptures.isUpdatedProfitAndLoss);
    const isUpdatedPlayer = useSelector((state:any) => state.dataCaptures.isUpdatedPlayer);
    const isUpdatedSupportFund = useSelector((state:any) => state.dataCaptures.isUpdatedSupportFund);
    const isAdmin = useSelector((state:any) => state.common.isAdmin);
    const standardIds = useSelector((state:any) => state.licence.licenceCriteriaStandards?.map((standard:any) => standard.id));
    const standards = useSelector((state:any) => state.licence.licenceCriteriaStandards);

    const maxLength = 300;

    const shouldTruncate = selectedLicenceStandard?.description && selectedLicenceStandard?.description?.length > maxLength;
    const descriptionText = !expanded && shouldTruncate
        ? selectedLicenceStandard?.description.slice(0, maxLength) + '...'
        : selectedLicenceStandard?.description;

    const manageLicenceData = (standardNumber:any) => {
        switch(standardNumber) {
            case 1:
                return (
                    <>
                    <CompanyDetails />
                    <ContactDetails />
                    </>
                );
            case 2:
                return (
                    <>
                    {
                        !isAdmin &&
                        <DataCaptureHeaders 
                        currentComponent={'staff'} 
                        isFieldsReadOnly={false} 
                        disableClearAll={staffDetails.length === 0} />
                    }
                    <StafffDetails />
                    </>
                );
            case 3:
                return (
                    <>
                    {
                        !isAdmin &&
                        <DataCaptureHeaders 
                        currentComponent={'facility'} 
                        isFieldsReadOnly={false} 
                        disableClearAll={facilitiesDetails.length === 0} />
                    }
                    <FacilityDetails />
                    </>
                );
            case 4:
                return (
                    <>
                    {
                        !isAdmin &&
                        <DataCaptureHeaders 
                        currentComponent={'teams'} 
                        isFieldsReadOnly={false} 
                        disableClearAll={teamDetails.length === 0} />
                    }
                    <TeamsDetails />
                    </>
                );
            case 5:
                return (
                    <>
                    <AccountingDetails />
                    </>
                );
            case 8:
                return (
                    <>
                    {
                        !isAdmin &&
                        <DataCaptureHeaders 
                        currentComponent={'players'} 
                        isFieldsReadOnly={false} 
                        disableClearAll={playerDetails.length === 0} />
                    }
                    <PlayersDetails />
                    </>
                );
            default:
                return(
                    <>
                    NO RECORDS FOUND
                    </>
                )
        }
    }

    const handleClickInsidePopper = (event: MouseEvent) => {
        event.stopPropagation();
    }

    //api update for the datacaptures
    const manageHandleClose = () => {
        switch(selectedLicenceStandard?.id) {
            case 1:
                saveCompanyDetails({ clubId: currentClub.id, data: companyDetails });
                saveContactDetails({ clubId: currentClub.id, data: contactDetails });
                break;
            case 2:
                isUpdatedStaff && 
                saveStaffDetails({ clubId: currentClub.id, data: staffDetails })
                .then((res:any) => {
                    dispatch(setStaffDetails(res));
                    const tempIsUpdatedStaff:any = false;
                    dispatch(setIsUpdatedStaff(tempIsUpdatedStaff));
                });
                break;
            case 3:
                isUpdatedFacility && 
                saveFacilities({clubId: currentClub?.id, data: facilitiesDetails})
                .then((response:any) => {
                    dispatch(setFacilitiesDetails(response));
                });
                const tempIsUpdatedFacility:any = false;
                dispatch(setIsUpdatedFacility(tempIsUpdatedFacility));
                break;
            case 4:
                isUpdatedTeam &&
                saveTeamDetails({clubId: currentClub?.id, data: teamDetails})
                .then((response:any) => {
                dispatch(setTeamDetails(response));
                });
                const tempIsUpdatedTeam:any = false;
                dispatch(setIsUpdatedTeam(tempIsUpdatedTeam));
                break;
            case 5:
                isUpdatedProfitAndLoss && 
                saveProfitAndLoss({ clubId: currentClub.id, data: profitAndLossDetails })
                .then((res:any) => {
                    dispatch(setProfitAndLossDetails(res));
                    const tempIsUpdatedProfitAndLoss:any = false;
                    dispatch(setIsUpdatedProfitAndLoss(tempIsUpdatedProfitAndLoss));
                });
                isUpdatedSupportFund && 
                saveSupportFund({ clubId: currentClub.id, data: supportFundDetails })
                .then((res:any) => {
                    dispatch(setSupportFundDetails(res));
                    const tempIsUpdatedSupportFund:any = false;
                    dispatch(setIsUpdatedSupportFund(tempIsUpdatedSupportFund));
                });
                break;
            case 8:
                isUpdatedPlayer &&
                savePlayers({clubId: currentClub?.id, data: playerDetails})
                .then((response:any) => {
                    dispatch(setPlayerDetails(response));
                    const tempIsUpdatedPlayer:any = false;
                    dispatch(setIsUpdatedPlayer(tempIsUpdatedPlayer));
                });
                break;
        }
        handleClose();
    }

    return(
        <React.Fragment>
            <ThemeProvider theme={theme}>
            <Popper className='popperStyle' open={isOpen} transition>
                    {({ TransitionProps }) => (
            <ClickAwayListener onClickAway={manageHandleClose}>
                <Fade {...TransitionProps} timeout={350}>
                            <Paper className='paperWrapperLicenceStandards' sx={{ p: 2, width: '1200px', mt: '20px', height: '650px' }} onClick={() => handleClickInsidePopper}>
                                <Box className={'detailsWrapper'} sx={{ display: 'flex', justifyContent: 'space-between'}}>
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'column', width: '80%' }}>
                                        <Typography className='standardsHeadingLicence uppercase'>{genUID(selectedLicenceStandard?.uid)} {selectedLicenceStandard?.name}</Typography>
                                        <Typography className='fs13'>
                                            {descriptionText}
                                            <Typography className='fs13 displayinlineBlock' onClick={toggleExpanded}>
                                                {descriptionText?.length < maxLength ? '' : expanded ? '(Show less)' : '(Show more)'}
                                            </Typography>
                                        </Typography>
                                    </Box>
                                    <Navigators 
                                    navigatorIds={standardIds} 
                                    navigatorData={standards} 
                                    manageStateChange={(tempData:any) => {dispatch(setSelectedLicenceStandard(tempData))}} />
                                    {/* <Typography className='fs13'>{selectedLicenceStandard?.standardsOverview}</Typography> */}
                                </Box>
                                <Box className={'licenceStandardDetailsContainer'}>
                                    {/* licence Data */}
                                    <Box className={'detailsWrapper'}>
                                        <Typography className='licenceStandardsHeading uppercase'>Licence Data</Typography>
                                        {
                                            manageLicenceData(selectedLicenceStandard?.id)
                                        }
                                    </Box>
                                    {/* Actions Data */}
                                    <Box className={'detailsWrapper'}>
                                        <Typography className='licenceStandardsHeading uppercase'>Actions</Typography>
                                        <ActionContents standard={selectedLicenceStandard} />
                                    </Box>
                                    {/* evidence wrapper */}
                                    <Box className={'detailsWrapper'}>
                                        <Typography className='licenceStandardsHeading uppercase'>Evidence</Typography>
                                        <EvidenceContents standardId={selectedLicenceStandard?.id} />
                                    </Box>
                                    {/* commentsWrapper */}
                                    <Box className={'detailsWrapper'}>
                                        <Typography className='licenceStandardsHeading uppercase'>Comments</Typography>
                                        <CommentsContents />
                                    </Box>
                                    {/* evaluation */}
                                    {
                                        isAdmin &&
                                        <Box className={'detailsWrapper'}>
                                            <Typography className='licenceStandardsHeading uppercase'>Evaluation</Typography>
                                            <EvaluationContents/>
                                        </Box>
                                    }
                                    {/* Admin Actions Data */}
                                    {/* <Box className={'detailsWrapper'}>
                                        <Typography className='licenceStandardsHeading uppercase'>Admin Actions</Typography>
                                        <AdminActionContents standard={selectedLicenceStandard} />
                                    </Box> */}
                                </Box>
                            </Paper>
                        </Fade>
                    </ClickAwayListener>
                    )}
                </Popper>
            </ThemeProvider>
        </React.Fragment>
    )
}

export default LicenceStandardsDetail;